/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetPeriodicSmartSmsRequestByIdDto } from '../models/custom-result-of-get-periodic-smart-sms-request-by-id-dto';
import { CustomResultOfGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto } from '../models/custom-result-of-get-periodic-smart-sms-request-statistics-with-request-details-dto';
import { CustomResultOfGetSmartSmsRequestByIdDto } from '../models/custom-result-of-get-smart-sms-request-by-id-dto';
import { CustomResultOfGetSmartSmsRequestByIdForDetailDto } from '../models/custom-result-of-get-smart-sms-request-by-id-for-detail-dto';
import { CustomResultOfInteger } from '../models/custom-result-of-integer';
import { CustomResultOfListOfGetActivePeriodicSmartSmsRequestsDto } from '../models/custom-result-of-list-of-get-active-periodic-smart-sms-requests-dto';
import { CustomResultOfListOfGetPeriodicSmartSmsRequestStatisticsDto } from '../models/custom-result-of-list-of-get-periodic-smart-sms-request-statistics-dto';
import { CustomResultOfListOfSmartSmsStatisticsDailyDeliveryCountResult } from '../models/custom-result-of-list-of-smart-sms-statistics-daily-delivery-count-result';
import { CustomResultOfPaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto } from '../models/custom-result-of-paginated-list-of-get-smart-sms-request-recipients-by-request-id-dto';
import { CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-smart-sms-requests-with-pagination-dto';
import { CustomResultOfSmartSmsRequestStatus } from '../models/custom-result-of-smart-sms-request-status';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { smartSmsRequestsCreateGet } from '../fn/smart-sms-requests/smart-sms-requests-create-get';
import { SmartSmsRequestsCreateGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-create-get';
import { smartSmsRequestsCreatePost } from '../fn/smart-sms-requests/smart-sms-requests-create-post';
import { SmartSmsRequestsCreatePost$Params } from '../fn/smart-sms-requests/smart-sms-requests-create-post';
import { smartSmsRequestsCreateResidentSmartSmsRequest } from '../fn/smart-sms-requests/smart-sms-requests-create-resident-smart-sms-request';
import { SmartSmsRequestsCreateResidentSmartSmsRequest$Params } from '../fn/smart-sms-requests/smart-sms-requests-create-resident-smart-sms-request';
import { smartSmsRequestsCreateSmartSmsRequestByFileGet } from '../fn/smart-sms-requests/smart-sms-requests-create-smart-sms-request-by-file-get';
import { SmartSmsRequestsCreateSmartSmsRequestByFileGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-create-smart-sms-request-by-file-get';
import { smartSmsRequestsCreateSmartSmsRequestByFilePost } from '../fn/smart-sms-requests/smart-sms-requests-create-smart-sms-request-by-file-post';
import { SmartSmsRequestsCreateSmartSmsRequestByFilePost$Params } from '../fn/smart-sms-requests/smart-sms-requests-create-smart-sms-request-by-file-post';
import { smartSmsRequestsDelete } from '../fn/smart-sms-requests/smart-sms-requests-delete';
import { SmartSmsRequestsDelete$Params } from '../fn/smart-sms-requests/smart-sms-requests-delete';
import { smartSmsRequestsDownloadCreateSmartSmsRequestGet } from '../fn/smart-sms-requests/smart-sms-requests-download-create-smart-sms-request-get';
import { SmartSmsRequestsDownloadCreateSmartSmsRequestGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-download-create-smart-sms-request-get';
import { smartSmsRequestsDownloadCreateSmartSmsRequestPost } from '../fn/smart-sms-requests/smart-sms-requests-download-create-smart-sms-request-post';
import { SmartSmsRequestsDownloadCreateSmartSmsRequestPost$Params } from '../fn/smart-sms-requests/smart-sms-requests-download-create-smart-sms-request-post';
import { smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet } from '../fn/smart-sms-requests/smart-sms-requests-down-load-smart-sms-request-status-result-get';
import { SmartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-down-load-smart-sms-request-status-result-get';
import { smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost } from '../fn/smart-sms-requests/smart-sms-requests-down-load-smart-sms-request-status-result-post';
import { SmartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Params } from '../fn/smart-sms-requests/smart-sms-requests-down-load-smart-sms-request-status-result-post';
import { smartSmsRequestsGetActivePeriodicSmartSmsRequests } from '../fn/smart-sms-requests/smart-sms-requests-get-active-periodic-smart-sms-requests';
import { SmartSmsRequestsGetActivePeriodicSmartSmsRequests$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-active-periodic-smart-sms-requests';
import { smartSmsRequestsGetPeriodicSmartSmsRequestStatistics } from '../fn/smart-sms-requests/smart-sms-requests-get-periodic-smart-sms-request-statistics';
import { SmartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-periodic-smart-sms-request-statistics';
import { smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails } from '../fn/smart-sms-requests/smart-sms-requests-get-periodic-smart-sms-request-statistics-with-request-details';
import { SmartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-periodic-smart-sms-request-statistics-with-request-details';
import { smartSmsRequestsGetResellerSmartSmsRequestsWithPagination } from '../fn/smart-sms-requests/smart-sms-requests-get-reseller-smart-sms-requests-with-pagination';
import { SmartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-reseller-smart-sms-requests-with-pagination';
import { smartSmsRequestsGetSmartSmsRequestById } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-by-id';
import { SmartSmsRequestsGetSmartSmsRequestById$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-by-id';
import { smartSmsRequestsGetSmartSmsRequestByIdForDetail } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-by-id-for-detail';
import { SmartSmsRequestsGetSmartSmsRequestByIdForDetail$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-by-id-for-detail';
import { smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-recipients-by-request-id';
import { SmartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-request-recipients-by-request-id';
import { smartSmsRequestsGetSmartSmsRequestsWithPagination } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-requests-with-pagination';
import { SmartSmsRequestsGetSmartSmsRequestsWithPagination$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-requests-with-pagination';
import { smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-statistics-daily-or-monthly-delivery-count';
import { SmartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Params } from '../fn/smart-sms-requests/smart-sms-requests-get-smart-sms-statistics-daily-or-monthly-delivery-count';
import { smartSmsRequestsRefreshSmartSmsRequestStatus } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status';
import { SmartSmsRequestsRefreshSmartSmsRequestStatus$Params } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status';
import { smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status-by-file-get';
import { SmartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status-by-file-get';
import { smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status-by-file-post';
import { SmartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Params } from '../fn/smart-sms-requests/smart-sms-requests-refresh-smart-sms-request-status-by-file-post';
import { smartSmsRequestsUpdatePeriodicSmartSmsRequestGet } from '../fn/smart-sms-requests/smart-sms-requests-update-periodic-smart-sms-request-get';
import { SmartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Params } from '../fn/smart-sms-requests/smart-sms-requests-update-periodic-smart-sms-request-get';
import { smartSmsRequestsUpdatePeriodicSmartSmsRequestPost } from '../fn/smart-sms-requests/smart-sms-requests-update-periodic-smart-sms-request-post';
import { SmartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Params } from '../fn/smart-sms-requests/smart-sms-requests-update-periodic-smart-sms-request-post';
import { smartSmsRequestsUpdateSmartSmsRequestIsActive } from '../fn/smart-sms-requests/smart-sms-requests-update-smart-sms-request-is-active';
import { SmartSmsRequestsUpdateSmartSmsRequestIsActive$Params } from '../fn/smart-sms-requests/smart-sms-requests-update-smart-sms-request-is-active';

@Injectable({ providedIn: 'root' })
export class SmartSmsRequestsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smartSmsRequestsCreateGet()` */
  static readonly SmartSmsRequestsCreateGetPath = '/SmartSmsRequests/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsCreateGet$Response(params?: SmartSmsRequestsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRequestsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsCreateGet(params?: SmartSmsRequestsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRequestsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsCreatePost()` */
  static readonly SmartSmsRequestsCreatePostPath = '/SmartSmsRequests/Create';

  /**
   * Create SmartSmsRequest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsCreatePost$Response(params: SmartSmsRequestsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInteger>> {
    return smartSmsRequestsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create SmartSmsRequest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsCreatePost(params: SmartSmsRequestsCreatePost$Params, context?: HttpContext): Observable<CustomResultOfInteger> {
    return this.smartSmsRequestsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInteger>): CustomResultOfInteger => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsRefreshSmartSmsRequestStatus()` */
  static readonly SmartSmsRequestsRefreshSmartSmsRequestStatusPath = '/SmartSmsRequests/RefreshSmartSmsRequestStatus';

  /**
   * Refresh SmartSmsRequest Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsRefreshSmartSmsRequestStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatus$Response(params: SmartSmsRequestsRefreshSmartSmsRequestStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSmartSmsRequestStatus>> {
    return smartSmsRequestsRefreshSmartSmsRequestStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Refresh SmartSmsRequest Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsRefreshSmartSmsRequestStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatus(params: SmartSmsRequestsRefreshSmartSmsRequestStatus$Params, context?: HttpContext): Observable<CustomResultOfSmartSmsRequestStatus> {
    return this.smartSmsRequestsRefreshSmartSmsRequestStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSmartSmsRequestStatus>): CustomResultOfSmartSmsRequestStatus => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetSmartSmsRequestsWithPagination()` */
  static readonly SmartSmsRequestsGetSmartSmsRequestsWithPaginationPath = '/SmartSmsRequests/GetSmartSmsRequestsWithPagination';

  /**
   * For each organization users get SmartSmsRequests current organization with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetSmartSmsRequestsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetSmartSmsRequestsWithPagination$Response(params: SmartSmsRequestsGetSmartSmsRequestsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto>> {
    return smartSmsRequestsGetSmartSmsRequestsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each organization users get SmartSmsRequests current organization with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetSmartSmsRequestsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetSmartSmsRequestsWithPagination(params: SmartSmsRequestsGetSmartSmsRequestsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto> {
    return this.smartSmsRequestsGetSmartSmsRequestsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto>): CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetResellerSmartSmsRequestsWithPagination()` */
  static readonly SmartSmsRequestsGetResellerSmartSmsRequestsWithPaginationPath = '/SmartSmsRequests/GetResellerSmartSmsRequestsWithPagination';

  /**
   * دریافت لیست درخواست های ارسال هوشمند فروشنده فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetResellerSmartSmsRequestsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Response(params: SmartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto>> {
    return smartSmsRequestsGetResellerSmartSmsRequestsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست درخواست های ارسال هوشمند فروشنده فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetResellerSmartSmsRequestsWithPagination(params: SmartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto> {
    return this.smartSmsRequestsGetResellerSmartSmsRequestsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto>): CustomResultOfPaginatedListOfGetSmartSmsRequestsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetSmartSmsRequestById()` */
  static readonly SmartSmsRequestsGetSmartSmsRequestByIdPath = '/SmartSmsRequests';

  /**
   * Get SmartSmsRequest By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetSmartSmsRequestById()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsRequestById$Response(params?: SmartSmsRequestsGetSmartSmsRequestById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSmartSmsRequestByIdDto>> {
    return smartSmsRequestsGetSmartSmsRequestById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get SmartSmsRequest By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetSmartSmsRequestById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsRequestById(params?: SmartSmsRequestsGetSmartSmsRequestById$Params, context?: HttpContext): Observable<CustomResultOfGetSmartSmsRequestByIdDto> {
    return this.smartSmsRequestsGetSmartSmsRequestById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSmartSmsRequestByIdDto>): CustomResultOfGetSmartSmsRequestByIdDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsDelete()` */
  static readonly SmartSmsRequestsDeletePath = '/SmartSmsRequests/Delete';

  /**
   * Delete SmartSmsRequest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDelete$Response(params: SmartSmsRequestsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete SmartSmsRequest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDelete(params: SmartSmsRequestsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsCreateResidentSmartSmsRequest()` */
  static readonly SmartSmsRequestsCreateResidentSmartSmsRequestPath = '/SmartSmsRequests/CreateResidentSmartSmsRequest';

  /**
   * ایجاد درخواست ارسال هوشمند ساکنین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsCreateResidentSmartSmsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsCreateResidentSmartSmsRequest$Response(params: SmartSmsRequestsCreateResidentSmartSmsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsCreateResidentSmartSmsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد درخواست ارسال هوشمند ساکنین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsCreateResidentSmartSmsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsCreateResidentSmartSmsRequest(params: SmartSmsRequestsCreateResidentSmartSmsRequest$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsCreateResidentSmartSmsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsCreateSmartSmsRequestByFileGet()` */
  static readonly SmartSmsRequestsCreateSmartSmsRequestByFileGetPath = '/SmartSmsRequests/CreateSmartSmsRequestByFile';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsCreateSmartSmsRequestByFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsCreateSmartSmsRequestByFileGet$Response(params?: SmartSmsRequestsCreateSmartSmsRequestByFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRequestsCreateSmartSmsRequestByFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsCreateSmartSmsRequestByFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsCreateSmartSmsRequestByFileGet(params?: SmartSmsRequestsCreateSmartSmsRequestByFileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRequestsCreateSmartSmsRequestByFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsCreateSmartSmsRequestByFilePost()` */
  static readonly SmartSmsRequestsCreateSmartSmsRequestByFilePostPath = '/SmartSmsRequests/CreateSmartSmsRequestByFile';

  /**
   * ایجاد درخواست هوشمند با فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsCreateSmartSmsRequestByFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRequestsCreateSmartSmsRequestByFilePost$Response(params?: SmartSmsRequestsCreateSmartSmsRequestByFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsCreateSmartSmsRequestByFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد درخواست هوشمند با فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsCreateSmartSmsRequestByFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRequestsCreateSmartSmsRequestByFilePost(params?: SmartSmsRequestsCreateSmartSmsRequestByFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsCreateSmartSmsRequestByFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet()` */
  static readonly SmartSmsRequestsRefreshSmartSmsRequestStatusByFileGetPath = '/SmartSmsRequests/RefreshSmartSmsRequestStatusByFile';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Response(params?: SmartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet(params?: SmartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRequestsRefreshSmartSmsRequestStatusByFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost()` */
  static readonly SmartSmsRequestsRefreshSmartSmsRequestStatusByFilePostPath = '/SmartSmsRequests/RefreshSmartSmsRequestStatusByFile';

  /**
   * ویرایش وضعیت درخواست های هوشمند با فایل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Response(params?: SmartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش وضعیت درخواست های هوشمند با فایل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost(params?: SmartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsDownloadCreateSmartSmsRequestGet()` */
  static readonly SmartSmsRequestsDownloadCreateSmartSmsRequestGetPath = '/SmartSmsRequests/DownloadCreateSmartSmsRequest';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsDownloadCreateSmartSmsRequestGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsDownloadCreateSmartSmsRequestGet$Response(params?: SmartSmsRequestsDownloadCreateSmartSmsRequestGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRequestsDownloadCreateSmartSmsRequestGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsDownloadCreateSmartSmsRequestGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsDownloadCreateSmartSmsRequestGet(params?: SmartSmsRequestsDownloadCreateSmartSmsRequestGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRequestsDownloadCreateSmartSmsRequestGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsDownloadCreateSmartSmsRequestPost()` */
  static readonly SmartSmsRequestsDownloadCreateSmartSmsRequestPostPath = '/SmartSmsRequests/DownloadCreateSmartSmsRequest';

  /**
   * دریافت لینک دانلود فایل ایجاد درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsDownloadCreateSmartSmsRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDownloadCreateSmartSmsRequestPost$Response(params: SmartSmsRequestsDownloadCreateSmartSmsRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return smartSmsRequestsDownloadCreateSmartSmsRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لینک دانلود فایل ایجاد درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsDownloadCreateSmartSmsRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDownloadCreateSmartSmsRequestPost(params: SmartSmsRequestsDownloadCreateSmartSmsRequestPost$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.smartSmsRequestsDownloadCreateSmartSmsRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet()` */
  static readonly SmartSmsRequestsDownLoadSmartSmsRequestStatusResultGetPath = '/SmartSmsRequests/DownLoadSmartSmsRequestStatusResult';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Response(params?: SmartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet(params?: SmartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smartSmsRequestsDownLoadSmartSmsRequestStatusResultGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost()` */
  static readonly SmartSmsRequestsDownLoadSmartSmsRequestStatusResultPostPath = '/SmartSmsRequests/DownLoadSmartSmsRequestStatusResult';

  /**
   * دریافت لینک دانلود فایل وضعیت درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Response(params: SmartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لینک دانلود فایل وضعیت درخواست ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost(params: SmartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsUpdateSmartSmsRequestIsActive()` */
  static readonly SmartSmsRequestsUpdateSmartSmsRequestIsActivePath = '/SmartSmsRequests/UpdateSmartSmsRequestIsActive';

  /**
   * ویرایش فعال بودن درخواست.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsUpdateSmartSmsRequestIsActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsUpdateSmartSmsRequestIsActive$Response(params: SmartSmsRequestsUpdateSmartSmsRequestIsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsUpdateSmartSmsRequestIsActive(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش فعال بودن درخواست.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsUpdateSmartSmsRequestIsActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsUpdateSmartSmsRequestIsActive(params: SmartSmsRequestsUpdateSmartSmsRequestIsActive$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsUpdateSmartSmsRequestIsActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId()` */
  static readonly SmartSmsRequestsGetSmartSmsRequestRecipientsByRequestIdPath = '/SmartSmsRequests/GetSmartSmsRequestRecipientsByRequestId';

  /**
   * دریافت لیست جزییات درخواست ارسال هشومند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Response(params: SmartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto>> {
    return smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست جزییات درخواست ارسال هشومند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId(params: SmartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto> {
    return this.smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto>): CustomResultOfPaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsUpdatePeriodicSmartSmsRequestGet()` */
  static readonly SmartSmsRequestsUpdatePeriodicSmartSmsRequestGetPath = '/SmartSmsRequests/UpdatePeriodicSmartSmsRequest';

  /**
   * دریافت درخواست ارسال هوشمند برای ویرایش ارسال های دوره ای (کمپین) هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsUpdatePeriodicSmartSmsRequestGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Response(params?: SmartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPeriodicSmartSmsRequestByIdDto>> {
    return smartSmsRequestsUpdatePeriodicSmartSmsRequestGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت درخواست ارسال هوشمند برای ویرایش ارسال های دوره ای (کمپین) هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsUpdatePeriodicSmartSmsRequestGet(params?: SmartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Params, context?: HttpContext): Observable<CustomResultOfGetPeriodicSmartSmsRequestByIdDto> {
    return this.smartSmsRequestsUpdatePeriodicSmartSmsRequestGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPeriodicSmartSmsRequestByIdDto>): CustomResultOfGetPeriodicSmartSmsRequestByIdDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsUpdatePeriodicSmartSmsRequestPost()` */
  static readonly SmartSmsRequestsUpdatePeriodicSmartSmsRequestPostPath = '/SmartSmsRequests/UpdatePeriodicSmartSmsRequest';

  /**
   * ویرایش ارسال های دوره ای (کمپین) هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsUpdatePeriodicSmartSmsRequestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Response(params: SmartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smartSmsRequestsUpdatePeriodicSmartSmsRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش ارسال های دوره ای (کمپین) هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smartSmsRequestsUpdatePeriodicSmartSmsRequestPost(params: SmartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smartSmsRequestsUpdatePeriodicSmartSmsRequestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetPeriodicSmartSmsRequestStatistics()` */
  static readonly SmartSmsRequestsGetPeriodicSmartSmsRequestStatisticsPath = '/SmartSmsRequests/GetPeriodicSmartSmsRequestStatistics';

  /**
   * دریافت آمار ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetPeriodicSmartSmsRequestStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Response(params?: SmartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPeriodicSmartSmsRequestStatisticsDto>> {
    return smartSmsRequestsGetPeriodicSmartSmsRequestStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetPeriodicSmartSmsRequestStatistics(params?: SmartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPeriodicSmartSmsRequestStatisticsDto> {
    return this.smartSmsRequestsGetPeriodicSmartSmsRequestStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPeriodicSmartSmsRequestStatisticsDto>): CustomResultOfListOfGetPeriodicSmartSmsRequestStatisticsDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount()` */
  static readonly SmartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCountPath = '/SmartSmsRequests/GetSmartSmsStatisticsDailyOrMonthlyDeliveryCount';

  /**
   * دریافت آمار ارسال هوشمند.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Response(params?: SmartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSmartSmsStatisticsDailyDeliveryCountResult>> {
    return smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار ارسال هوشمند.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount(params?: SmartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Params, context?: HttpContext): Observable<CustomResultOfListOfSmartSmsStatisticsDailyDeliveryCountResult> {
    return this.smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSmartSmsStatisticsDailyDeliveryCountResult>): CustomResultOfListOfSmartSmsStatisticsDailyDeliveryCountResult => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetSmartSmsRequestByIdForDetail()` */
  static readonly SmartSmsRequestsGetSmartSmsRequestByIdForDetailPath = '/SmartSmsRequests/GetSmartSmsRequestByIdForDetail';

  /**
   * دریافت درخواست ارسال هوشمند بر اساس آیدی با جزییات کامل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetSmartSmsRequestByIdForDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsRequestByIdForDetail$Response(params?: SmartSmsRequestsGetSmartSmsRequestByIdForDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSmartSmsRequestByIdForDetailDto>> {
    return smartSmsRequestsGetSmartSmsRequestByIdForDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت درخواست ارسال هوشمند بر اساس آیدی با جزییات کامل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetSmartSmsRequestByIdForDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetSmartSmsRequestByIdForDetail(params?: SmartSmsRequestsGetSmartSmsRequestByIdForDetail$Params, context?: HttpContext): Observable<CustomResultOfGetSmartSmsRequestByIdForDetailDto> {
    return this.smartSmsRequestsGetSmartSmsRequestByIdForDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSmartSmsRequestByIdForDetailDto>): CustomResultOfGetSmartSmsRequestByIdForDetailDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails()` */
  static readonly SmartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsPath = '/SmartSmsRequests/GetPeriodicSmartSmsRequestStatisticsWithRequestDetails';

  /**
   * دریافت درخواست ارسال هوشمند بر اساس آیدی با جزییات کامل  و آمار کلی ارسال.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Response(params?: SmartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto>> {
    return smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت درخواست ارسال هوشمند بر اساس آیدی با جزییات کامل  و آمار کلی ارسال.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails(params?: SmartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Params, context?: HttpContext): Observable<CustomResultOfGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto> {
    return this.smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto>): CustomResultOfGetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto => r.body)
    );
  }

  /** Path part for operation `smartSmsRequestsGetActivePeriodicSmartSmsRequests()` */
  static readonly SmartSmsRequestsGetActivePeriodicSmartSmsRequestsPath = '/SmartSmsRequests/GetActivePeriodicSmartSmsRequests';

  /**
   * دریافت کمپین های هوشمند فعال سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smartSmsRequestsGetActivePeriodicSmartSmsRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetActivePeriodicSmartSmsRequests$Response(params?: SmartSmsRequestsGetActivePeriodicSmartSmsRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetActivePeriodicSmartSmsRequestsDto>> {
    return smartSmsRequestsGetActivePeriodicSmartSmsRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت کمپین های هوشمند فعال سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smartSmsRequestsGetActivePeriodicSmartSmsRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smartSmsRequestsGetActivePeriodicSmartSmsRequests(params?: SmartSmsRequestsGetActivePeriodicSmartSmsRequests$Params, context?: HttpContext): Observable<CustomResultOfListOfGetActivePeriodicSmartSmsRequestsDto> {
    return this.smartSmsRequestsGetActivePeriodicSmartSmsRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetActivePeriodicSmartSmsRequestsDto>): CustomResultOfListOfGetActivePeriodicSmartSmsRequestsDto => r.body)
    );
  }

}
